export default __webpack_public_path__ + "static/media/Tabl_4.63ec9169.svg";